export const RECORD_COUPON_VIEW_REQUEST = "RECORD_COUPON_VIEW_REQUEST";
export const RECORD_COUPON_VIEW_SUCCESS = "RECORD_COUPON_VIEW_SUCCESS";
export const RECORD_COUPON_VIEW_FAILURE = "RECORD_COUPON_VIEW_FAILURE";

export const COUPON_VIEW_CLEAR = "COUPON_VIEW_CLEAR";
